<template>
  <div class="container-root">
    <Breadcrumb :items.sync="breadcrumb"></Breadcrumb>
    <div v-if="breadcrumb.length === 1">
      <div class="header-group">
        <h2 style="margin: 0px; font-weight: bold">STAFF PAYSLIPS</h2>
        <div class="loader" v-if="isLoading || isDownloading"></div>
        <button
          class="button dark-blue"
          v-if="
            !this.list.isLoading &&
              !isLoading &&
              !isDownloading &&
              !canGeneratePayslips()
          "
          @click="publishPayslips()"
        >
          <div style="font-size: 0.9em">PUBLISH</div>
        </button>
        <button
          class="button dark-blue"
          v-if="!this.list.isLoading && !isLoading && !isDownloading"
          @click="
            canGeneratePayslips() ? generatePayslips() : downloadPayslips()
          "
        >
          <div style="font-size: 0.9em">
            {{ !canGeneratePayslips() ? 'DOWNLOAD' : 'GENERATE' }}
          </div>
        </button>
      </div>
      <div style="margin-top: 25px">
        <Table
          :title="'Payslips'"
          :model="list.table"
          :isLoading="list.isLoading"
          :selectedId.sync="selectedId"
          :filterIndex="1"
        >
          <div class="control-group">
            <div class="control-title">MONTH</div>
            <select class="control" v-model="month.selected">
              <option
                v-for="option in month.data"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="control-group">
            <div class="control-title">YEAR</div>
            <!-- <h3 style="margin:0px">{{year.selected}}</h3> -->
            <select class="control" v-model="year.selected">
              <option v-for="(option, optionIdx) in year.data" :key="optionIdx">
                {{ option }}
              </option>
            </select>
          </div>
        </Table>
      </div>
    </div>
    <PayslipDetails
      v-if="breadcrumb.length === 2"
      :model.sync="selectedModel"
      :notif.sync="notif"
      :month="month.selected"
      :year="year.selected"
      :profile="profile"
      :isEditable="true"
    ></PayslipDetails>
    <Notif v-if="notif" :data.sync="notif"></Notif>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';
import XLSX from 'xlsx';
import { utils, http } from '../digilib_web/core/digitify';
import { constants, regentsUtils } from '../js/regents';
import Table from '../digilib_web/vue/table';
import Breadcrumb from '../digilib_web/vue/breadcrumb';
import Notif from '../digilib_web/vue/notif';
import PayslipDetails from './staff_payslips_details';

export default {
  props: {
    profile: Object
  },
  watch: {
    breadcrumb: {
      handler(n, o) {
        // reset data when home
        if (n.length === 1 && o.length === 2) {
          this.selectedId = -1;
          this.reloadTable();
        }
      }
    },
    selectedId: {
      handler(id) {
        if (id > -1) {
          // set selected model
          this.selectedModel = this.list.payslips.find(x => x.id === id);
          let selectedMonth = this.month.data.find(
            x => x.id === this.month.selected
          ).name;
          // set the breadcrumb
          this.breadcrumb.push({
            text: `${this.selectedModel.employee_name} : ${selectedMonth} ${
              this.year.selected
            } Payslip`
          });
        }
      }
    },
    'month.selected': {
      handler(n, o) {
        if (n !== o) {
          this.reloadTable();
        }
      }
    },
    'year.selected': {
      handler(n) {
        this.reloadTable();
      }
    }
  },
  methods: {
    canGeneratePayslips() {
      return this.list.payslips.length === 0;
    },
    generatePayslips() {
      console.log(this.month.selected, this.year.selected);

      this.isLoading = true;
      let endpoint = `employees/payslips/generate/${this.month.selected}/${
        this.year.selected
      }`;
      http.get(endpoint).then(json => {
        console.log(json);

        this.isLoading = false;
        if (json.success) {
          this.reloadTable();
        }
      });
    },
    publishPayslips() {
      if (confirm(`Are you sure you want to publish the payslips ?`)) {
        let endpoint = `employees/payslips/publish/${this.month.selected}/${
          this.year.selected
        }`;
        http.get(endpoint).then(json => {
          if (!json.success) {
            this.publishPayslips();
          } else {
            alert('Payslips published!');
          }
        });
      }
    },
    downloadPayslips() {
      this.isDownloading = true;
      let m = this.month.selected;
      let y = this.year.selected;
      let endpoint = `employees/attendance/annually/${y}`;
      http.get(endpoint).then(json => {
        // group by id employee
        let employees = {};
        json.data.forEach(item => {
          let idEmp = item.id_employee;
          if (!employees[idEmp]) {
            employees[idEmp] = {
              clockIns: [],
              countLate: 0,
              department: item.department,
              deduction: 0
            };
          }
          employees[idEmp].clockIns.push({ clock_in: item.clock_in });
        });
        let promises = [];
        for (let k in employees) {
          let clockIns = employees[k].clockIns;
          let department = employees[k].department;
          employees[k].countLate = regentsUtils.countAnnualLateness(
            clockIns,
            department
          );
          let e = `${
            process.env.VUE_APP_ROOT_API
          }employees/attendance/monthly/${m}/${y}?where=id_employee,=,${k}`;
          promises.push(axios.get(e, { withCredentials: true }));
        }
        // requests
        axios.all(promises).then(results => {
          results.forEach(response => {
            let json = response.data.data;
            if (json.length > 0) {
              let idEmp = json[0].id_employee;
              let employee = employees[idEmp];
              json.forEach(item => {
                let d = regentsUtils.attendanceDeduction(
                  item,
                  employee.countLate
                );
                employee.deduction += d.deduction;
              });
            }
          });
          // calculate
          let data = [];
          for (let i = 0; i < this.list.payslips.length; ++i) {
            let p = this.list.payslips[i];
            let d = {
              Name: p.employee_name,
              'Bank Name': p.bank,
              'Bank Account Name': p.bank_acc_no,
              Total: 0
            };
            this.earningFields.forEach(k => {
              let key = k.key;
              d.Total += p[key];
              d[k.text] = p[key];
            });
            this.deductionFields.forEach(k => {
              let key = k.key;
              d.Total -= p[key];
              d[k.text] = -p[key];
            });
            let countLate = employees[p.id_employee].countLate;
            // deduct only if late count exceeds minimum
            if (countLate > 10) {
              d.Total -= employees[p.id_employee].deduction;
            }
            d['Attendance Deduction'] = -employees[p.id_employee].deduction;
            data.push(d);
          }

          // remove all nans
          /*
          data.forEach(d => {
            for (let key in d) {
              if (Number.isNaN(d[key])) {
                d[key] = 0
              }
            }
          })
          */

          let ws = XLSX.utils.json_to_sheet(data);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'data');
          XLSX.writeFile(wb, `payroll-${m}-${y}.xlsx`);
          // we are done here
          // this.publishPayslips()
          this.isDownloading = false;
        });
      });
    },
    calculateTotal(orig) {
      const t = JSON.parse(JSON.stringify(orig));
      t.forEach(p => {
        let total = 0;
        this.earningFields.forEach(k => {
          let key = k.key;
          total += p[key];
        });
        this.deductionFields.forEach(k => {
          let key = k.key;
          total -= p[key];
        });
        // total -= employees[p.id_employee].deduction
        p['total'] = total;
      });

      console.log(t);

      return t;
    },
    reloadTable() {
      this.selectedId = -1;
      this.list.isLoading = true;
      // get the employees first
      http
        .get(
          `employees/payslips/list/${this.month.selected}/${this.year.selected}`
        )
        .then(json => {
          this.list.payslips = json.data;
          // generate the table data
          // let computed = this.calculateTotal(this.list.payslips)
          this.list.table = utils.toTable(this.list.payslips, {
            employee_name: { title: 'name' },
            department: { title: 'department' },
            salary: { title: 'basic salary' }
          });

          this.list.isLoading = false;
        });
    }
  },
  mounted() {
    // set selected month and year
    let m = dayjs();
    this.month.selected = parseInt(m.format('M'), 10);
    this.year.selected = parseInt(m.format('YYYY'), 10);
    this.reloadTable();
  },
  data() {
    return {
      countLate: 0,
      isLoading: false,
      isDownloading: false,
      notif: null,
      selectedId: -1,
      selectedModel: null,
      month: {
        data: constants.MONTHS,
        selected: null
      },
      year: {
        data: constants.YEARS,
        selected: null
      },
      list: {
        isLoading: false,
        table: {},
        payslips: []
      },
      breadcrumb: [{ icon: 'fa fa-home', text: 'staff payslips' }],
      earningFields: [
        { key: 'salary', text: 'Base Salary' },
        { key: 'functional_allowance', text: 'Functional Allowance' },
        { key: 'food_transport_allowance', text: 'Food Transport Allowance' },
        { key: 'discipline_bonus', text: 'Discipline Bonus' },
        { key: 'thr', text: 'THR' },
        { key: 'travel_bonus', text: 'Travel Bonus' },
        { key: 'end_year_bonus', text: 'End Year Bonus' },
        {
          key: 'bpjs_tenaker_school_contrib',
          text: 'BPJS Ketenagakerjaan School Contribution'
        },
        {
          key: 'bpjs_kesehatan_school_contrib',
          text: 'BPJS Kesehatan School Contribution'
        }
      ],
      deductionFields: [
        {
          key: 'bpjs_tenaker_contrib',
          text: 'BPJS Ketenagakerjaan Staff Contribution'
        },
        {
          key: 'bpjs_kesehatan_contrib',
          text: 'BPJS Kesehatan Staff Contribution'
        },
        { key: 'reksadana_contrib', text: 'Reksadana Contribution' },
        { key: 'cashbon', text: 'Cashbon' }
      ]
    };
  },
  components: {
    Table,
    Breadcrumb,
    PayslipDetails,
    Notif
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
}
</style>
